import qs from 'query-string'

const UrlUtils = {
    /**
     * @deprecated Use URLSearchParams instead
     * @param {Record<string, unknown} params 
     * @returns 
     */
    buildQueryString(params) {
        const enc = encodeURIComponent
        return Object.keys(params)
            .map((p) => `${enc(p)}=${enc(params[p])}`)
            .join('&')
    },

    /**
     * @deprecated Use URLSearchParams instead
     * @param {string} queryString 
     * @returns 
     */
    parseQueryString(queryString) {
        return qs.parse(queryString)
    },
}

export default UrlUtils
